import { memo, type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => {

  const {width = 27, height = 27} = props;

  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
     viewBox="0 0 27 27"
    {...props}
  >
    <path
      fill="currentColor"
      d="m8.417 19.727 4.734-4.734 4.735 4.734 1.841-1.841-4.734-4.735 4.734-4.734-1.841-1.841-4.735 4.734-4.734-4.734-1.841 1.84 4.734 4.735-4.734 4.735 1.84 1.841Zm4.734 6.576c-1.819 0-3.529-.346-5.129-1.036a13.274 13.274 0 0 1-4.175-2.81 13.272 13.272 0 0 1-2.81-4.177C.344 16.68 0 14.97 0 13.152c0-1.819.345-3.529 1.036-5.129.69-1.6 1.627-2.992 2.81-4.175a13.29 13.29 0 0 1 4.176-2.812C9.622.345 11.332 0 13.152 0c1.819 0 3.528.345 5.129 1.035a13.29 13.29 0 0 1 4.175 2.812 13.274 13.274 0 0 1 2.81 4.175c.691 1.6 1.037 3.31 1.037 5.13 0 1.819-.346 3.528-1.036 5.129a13.274 13.274 0 0 1-2.81 4.175 13.274 13.274 0 0 1-4.177 2.81c-1.6.691-3.31 1.037-5.129 1.037Zm0-2.63c2.938 0 5.425-1.02 7.464-3.058 2.038-2.039 3.058-4.526 3.058-7.464 0-2.937-1.02-5.425-3.058-7.463C18.576 3.65 16.089 2.63 13.15 2.63c-2.937 0-5.425 1.02-7.463 3.058C3.65 7.726 2.63 10.214 2.63 13.151c0 2.938 1.02 5.425 3.058 7.464 2.038 2.038 4.526 3.058 7.463 3.058Z"
    />
  </svg>
  );
};
const Memo = memo(SvgComponent);
export { Memo as ErrorIcon };
